import { dropAtivo, dropBoolean } from 'utils/drops';

const getProdutosFilterFields = (drops = {}) => [
  {
    name: 'id',
    label: 'ID',
    type: 'number',
  },
  {
    name: 'ativo',
    label: 'Ativo',
    type: 'select',
    options: dropAtivo,
    defaultValue: 'SIM',
  },
  {
    name: 'descricao',
    label: 'Descrição',
    initial: true,
  },
  {
    name: 'referencia',
    label: 'Referência',
  },
  {
    name: 'preco',
    label: 'Preço',
    type: 'currency',
  },
  {
    name: 'localizador',
    label: 'Localização',
  },
  {
    name: 'unidade',
    label: 'Unidade de Medida',
    type: 'select',
    options: drops?.UnidadeMedida,
    multiple: true,
  },
  {
    name: 'linha',
    label: 'Linha',
    type: 'select',
    options: drops?.LinhaProduto,
    multiple: true,
  },
  {
    name: 'grupo',
    label: 'Grupo',
    type: 'select',
    options: drops?.GrupoProduto,
    multiple: true,
  },
  {
    name: 'marca',
    label: 'Marca',
    type: 'select',
    options: drops?.Marca,
    multiple: true,
  },
  {
    name: 'ncm',
    label: 'NCM',
    type: 'virtual-select',
    options: drops?.Cfiscal,
    multiple: true,
  },
  {
    name: 'origem_tributaria',
    label: 'Origem Tributária',
    type: 'select',
    options: drops?.OrigemTributaria,
    multiple: true,
  },
  {
    name: 'complemento1',
    label: 'Complemento 1',
  },
  {
    name: 'complemento2',
    label: 'Complemento 2',
  },
  {
    name: 'rastreavel',
    label: 'Rastreável',
    type: 'select',
    options: dropBoolean,
  },
  {
    name: 'variacao',
    label: 'Variação',
    type: 'select',
    options: dropBoolean,
  },
  {
    name: 'especificacao',
    label: 'Especificação',
  },
];

export default getProdutosFilterFields;
